//判断是否为空
export const isEmptyUtils = (data) => {
  if (
    data === null ||
    data === '' ||
    data === undefined ||
    data.length === 0 ||
    data == 0
  ) {
    return true
  } else {
    return false
  }
}

//加密
export const md5Utils = (data) => {
  let crypto = require('crypto');
  let content = data;
  return crypto.createHash('md5').update(content).digest("hex")
}

//判断元素在数组中
export const inArrayUtils = (data, array) => {  
  var i = array.length;  
  while (i--) {  
      if (array[i] === data) {  
          return true;  
      }  
  }  
  return false;  
}  

//获取随机字符串
export const randomUtils = (number) => {
  number = number || 6;
  //设置随机数范围
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstucwxyz0123456789';
  let maxPos = chars.length;
  let r = '';
  for(let i = 0; i < number; i++) {
    //产生随机数方式
    r += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return r;
}


// WEBPACK FOOTER //
// ./src/utils/data.js